import App from '@components/visit/App.vue'
import { generateApplication } from '@helpers/generate_component.js';
import { generateAxiosInstance } from '@helpers/axios_provider.js';
import { createPinia } from 'pinia';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { autoAnimatePlugin } from "@formkit/auto-animate/vue"

const axios = generateAxiosInstance();
const injections = [
  {
    name: 'locale',
    module: locale
  }, {
    name: '$axios',
    module: generateAxiosInstance()
  },
  {
    name: '$contact',
    module: typeof contact !== 'undefined' ? contact : null
  }
]
const props = { registerForm: registerForm }
generateApplication(App, "#register-form", {
  packages: [{ name: '$axios', module: axios },VueSweetalert2,createPinia(),autoAnimatePlugin], injections, props
})